import { takeLatest, put, call, fork } from "redux-saga/effects";
import { MARKET_DATA_ACTIONS } from "constants/actions";
import {
    fetchedMarketData,
    failedCreateMarketData,
    createdMarketData,
    failedFetchMarketData,
    updatedMarketData,
    failedUpdateMarketData
} from "./../actions";
import { MarketDataService } from "services";

function* fetchMarketData({payload: {id}}) {
    const { data, error } = yield call(MarketDataService.getMarketData, id);
    if(!error) {
        yield put(fetchedMarketData(id, data));
    } else {
        yield put(failedFetchMarketData(error));
    }
}

function* createMarketData({payload: {id, market_data}}) {
    const { data, error } = yield call(MarketDataService.createMarketData, market_data);
    if(!error) {
        yield put(createdMarketData(id, data));
    } else {
        yield put(failedCreateMarketData(error));
    }
}

function* updateMarketData({payload: {id, market_data}}) {
    const { data, error } = yield call(MarketDataService.updateMarketData, id, market_data);
    if(!error) {
        yield put(updatedMarketData(id, data));
    } else {
        yield put(failedUpdateMarketData(error));
    }
}


export default fork(function*() {
    yield takeLatest(MARKET_DATA_ACTIONS.FETCH_MARKET_DATA, fetchMarketData);
    yield takeLatest(MARKET_DATA_ACTIONS.CREATE_MARKET_DATA, createMarketData);
    yield takeLatest(MARKET_DATA_ACTIONS.UPDATE_MARKET_DATA, updateMarketData);
});
